import { IconCalendar } from "@tabler/icons-react";
import { getGreetingBasedOnTime } from "../../constants";
import {
  daysUntilTaxDeadline,
  getCurrentDateString,
} from "@pages/TaxProHome/utils/utils";
import "./HomeHeader.scss";
import SearchBar from "@components/SearchBar/SearchBar";
import { Loader } from "@mantine/core";
import { useSearch } from "@utils/hooks/useSearch";
// TODO: OnboardingAlert needs to be refactored to use new Onboarding store
// import OnboardingAlert from "@/pages/Onboarding/components/OnboardingAlert";
// import RoleBased from "../RoleBased";
// import { Transition } from "@mantine/core";

interface TaxProHeaderProps {
  firstName?: string;
  isClient?: boolean;
}

const greetingMessage = getGreetingBasedOnTime();

const ClientsSearchBar = (): JSX.Element => {
  const { clients, isLoadingClients, isErrorClients } = useSearch();

  if (isErrorClients) {
    throw new Error("Error fetching clients");
  }

  return isLoadingClients ? <Loader /> : <SearchBar data={clients || []} />;
};

const HomeHeader = ({
  firstName,
  isClient,
}: TaxProHeaderProps): JSX.Element => {
  return (
    <div className="tax-pro-header">
      {/* TODO: OnboardingAlert needs to be refactored to use new Onboarding store */}
      {/* <RoleBased allowedRoles={["owner"]}>
        <Transition
          transition="slide-down"
          duration={500}
          mounted={isComponentLoaded}
          enterDelay={100}
          timingFunction="ease-in"
        >
          {(styles) => (
            <div style={{ ...styles, width: "100%" }}>
              <OnboardingAlert />
            </div>
          )}
        </Transition>
      </RoleBased> */}

      <div className="days-left-container">
        <div className="days-left">
          <IconCalendar />
          <p>{` ${daysUntilTaxDeadline()} days left to file`}</p>
        </div>
      </div>
      <p className="date-text">{getCurrentDateString()}</p>

      <h1>
        {greetingMessage}
        {firstName && `, ${firstName}`}!
      </h1>

      {!isClient && <ClientsSearchBar />}
    </div>
  );
};

export default HomeHeader;
